import { changeTagName } from '@sky-it-livedata/common-web-app-utils';

export function handleLMPHeadings() {
  setTimeout(() => {
    const lmpSlimWrapper = document.querySelector('.ftbl__hero-lmp-slim-wrapper');

    document.querySelectorAll('.ftbl__tabs-switch__content').forEach((tab) => {
      const h1 = tab.querySelector('h1');
      const h2 = tab.querySelector('h2');
      const style = getComputedStyle(tab);
      const isActive = style.display === 'block';
      if (isActive && h1) {
        return;
      }
      if (!isActive && !h1) {
        return;
      }
      if (!isActive && h1 && lmpSlimWrapper) {
        changeTagName(h1, 'h2');
        return;
      }
      if (isActive && !h1 && h2 && lmpSlimWrapper) {
        changeTagName(h2, 'h1');
      }
    });
  }, 0);
}
